<template>
  <div class="summarydetail">
    <div class="detail_wrapper">
      <div class="toolbar">
        <div class="info-header">
          <div class="title">{{userinfo.companyName}}</div>
          <div class="add">详细地址:{{userinfo.companyAddress}}</div>
          <div class="time">注册时间:{{userinfo.registerTime}}</div>
          <div>
            <el-button plain @click="goto('developer')">用户详情</el-button>
            <el-button plain @click="goto('developerdetail')">接口管理</el-button>
            <el-button type="primary">调用统计</el-button>
          </div>
          <div class="user">
            <img v-if="devStatus == '2'" src="../../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
            <img v-if="devStatus == '1'" src="../../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
            <img v-if="devStatus == '3'" src="../../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
            <img v-if="devStatus == '0'" src="../../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787">未生效用户</span>
            <img v-if="devStatus == '4'" src="../../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
            <img v-if="devStatus == '5'" src="../../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
          </div>
          <div style="margin-top:10px;">
            <span style="font-size:14px;font-weight:bold;margin-right:20px;">调用统计</span>
            <el-date-picker
              style="width: 400px;"
              v-model="selectDate"
              type="daterange"
              align="right"
              unlink-panels
              :clearable="false"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="loadTableData"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="content_wrapper" >
        <el-table
            :data="tableData"
            header-row-class-name="header-row-class-name"
            border
            v-loading="loading"
            style="width: 100%">

            <el-table-column
              label="接口名称"
              align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="资源类型"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.resourceType === 0">/</div>
                <div v-if="scope.row.apiResourceDto.resourceType === 1">普通</div>
                <div v-if="scope.row.apiResourceDto.resourceType === 2">精品</div>
              </template>
            </el-table-column> -->

            <!-- <el-table-column
              label="可用上限"
              align="center"
              prop="invokeLimit">
            </el-table-column>

            <el-table-column
              label="下载上限"
              align="center"
              prop="invokeCount">
            </el-table-column> -->

            <el-table-column
              label="去重下载"
              align="center"
              prop="downloadCount">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="累计下载"
              align="center"
              prop="totalDownloadCount">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.totalDownloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="接口总调用量"
              align="center"
              prop="invokeCount">
            </el-table-column>

          </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import statisticsService from '@/service/statisticsService'
import devService from '@/service/devService'
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      height: this.SysConstant.winHeight - 300,
      selectDate: [],
      details: {},
      pickDate: '',
      tableData: [],
      isOpen: true,
      loading: false,
      devStatus: '',
      type: '1'
    }
  },
  name: 'summarydetail',
  watch: {
    // $route (from, to) {
    //   this.detailService()
    // }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  async mounted () {
    let toDate = new Date().Format(this.SysConstant.DATE_FORMATE)
    let fromDate = this.userinfo.openingTime || (this.userinfo.registerTime && this.userinfo.registerTime.substr(0, 10)) || this.$util.getLast(-6)
    this.selectDate = [fromDate, toDate]
    await this.loadTableData()
    this.getDeveloperStatus()
  },
  methods: {
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.userinfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 跳转页面
    goto (name) {
      this.$router.push({name: name})
    },
    async loadTableData () {
      this.loading = true
      let params = {
        id: this.userinfo.id,
        companyName: this.userinfo.companyName,
        fromDate: this.selectDate[0],
        toDate: this.selectDate[1]
      }
      try {
        let data = await statisticsService.fetchDevDetailData(params)
        // 过滤apiResourceDto.name是试题的，然后questionV4的改名为试题
        data = data.filter(item => item.apiResourceDto.name !== '试题')
        data.forEach(item => {
          if (item.apiResourceDto.name === 'questionV4') {
            item.apiResourceDto.name = '试题'
          }
        })
        let sortArr = ['通用', '文档', '试卷', '试题', '微课'];
        data = data.map(item => {
          return {
            ...item,
            order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
          }
        })
        if (data) {
          this.tableData = data.sort((a, b) => {
            return a.order - b.order
          })
        } else {
          this.tableData = []
        }
        this.loading = false
      } catch (e) {
        this.$message.error(e && e.msg)
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
  .summarydetail{
    height: 100%;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 60px;
  }
  .summarydetail .detail_wrapper{
    height: 100%;
    width: 1200px;
    /* padding: 30px; */
    margin: 0 auto;
  }

  .summarydetail .detail_wrapper .toolbar{
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    background-color: #ffffff;
  }

  .summarydetail .detail_wrapper .toolbar .info-header{
    background: #ffffff;
    padding: 20px 24px;
    position: relative;
    color: #333;
  }
  .summarydetail .detail_wrapper .toolbar .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .summarydetail .detail_wrapper .toolbar .info-header .add,.summarydetail .detail_wrapper .toolbar .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .summarydetail .detail_wrapper .toolbar .info-header .user span{
    position: absolute;
    right: 121px;
    top: 54px;
    font-size: 18px;
    font-weight: bold;
  }
  .summarydetail .detail_wrapper .toolbar .info-header .user img{
    position: absolute;
    right: 200px;
    top: 50px;
  }
  .summarydetail .detail_wrapper .toolbar .el-select {
    width: 130px;
  }
  .summarydetail .detail_wrapper .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .summarydetail .detail_wrapper .content_wrapper{
    background-color: #ffffff;
    padding:30px 10px 30px 20px;
  }

  .summarydetail .detail_wrapper .toolbar .el-select {
    width: 130px;
  }
  .summarydetail .detail_wrapper .toolbar .input-with-select{
    width: 400px;
  }
  .summarydetail .detail_wrapper .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;

  }
  .summarydetail .detail_wrapper .content_wrapper{
    background-color: #ffffff;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/front/developer/summary/index.vue